var map = {
	"./circle-plus.svg": "cfc7",
	"./icon-copy.svg": "a765",
	"./icon-declare-check.svg": "ee7d",
	"./icon-eagle-black.svg": "5a92",
	"./icon-eagle-transparent.svg": "86d9",
	"./icon-eagle-white.svg": "11d9",
	"./icon-eagle.svg": "953d",
	"./icon-hand-completed.svg": "e138",
	"./icon-identity-white.svg": "67db",
	"./icon-key-white.svg": "6f6e",
	"./icon-refund.svg": "81af",
	"./icon-registration-mistake.svg": "7dde",
	"./icon-time-white.svg": "d8ea",
	"./lock-circle.svg": "4a99",
	"./question.svg": "bc93",
	"./success.svg": "71b4",
	"./theme-change.svg": "d4cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c3c";